import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { CancelInvitationRequest } from '../../../../../libs/client/src/generated';

export function useCancelInvitation(options?: UseMutationOptions<void, unknown, CancelInvitationRequest>) {
  return useMutation({
    mutationFn: async ({ invitationId }) => {
      const api = getPrivateApi();
      await api.cancelInvitation({ invitationId });
    },
    ...options,
  });
}
